"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const n=require("react/jsx-runtime"),o=require("./Favicons.cjs"),s=()=>n.jsx(o.Favicons,{cdnUrl:"https://cdn.aftenposten.no/ap/images/favicons/v1/"});exports.APFavicons=s;
//# sourceMappingURL=APFavicons.cjs.map
